import React from 'react';

interface Props {
  message: string;
}

export const MessageContent: React.FC<Props> = ({ message }) => {
  return <div dangerouslySetInnerHTML={{ __html: message }}></div>;
};
